import { IResultWithPagination } from 'reducers/models';
export interface IEquipments extends IResultWithPagination<IEquipment> { }

export interface IEquipmentsDetails extends IResultWithPagination<IEquipmentDetail> { }
export interface IEquipment {
    id: number,
    equipmentNumber: string,
    productType: string,
    status: string,
    consginee: string,
    loadingPortName: string,
    dischargePortName: string,
    loadingPortCode: string,
    dischargePortCode: string,
    shipper: string,
    lastChangedBy: string,
    finOpsStatus: string,
    carrier: string,
    carrierBooking: string,
    size: string,
    type: string,
    etsNumber: string,
    lastChangeDate: string
}
export interface IEquipmentDetail {
    bookings: any[],
    cbls: any[],
    createDate: string,
    destinationCustomsClearance: string;
    destinationOffice: string;
    destinationTrucking: string;
    documents: any[],
    clrs: any[],
    sealNumber1: string,
    deliveryMovementType: string,
    pickUpMovementType: string,
    equipmentParty: {
        companyCode: string,
        issuerCountryCode: string,
        placeOfDeliveryCode: string,
        placeOfDeliveryName:  string,
        placeOfReceiptCode: string,
        placeOfReceiptName: string,
        portOfDischargeCode: string,
        portOfDischargeName: string,
        portOfLoadingCode: string,
        portOfLoadingName: string,
        salesArea: string,
        issuerBECode:string;
    },
    equipmentId: number,
    equipmentNumber: string,
    equipmentTransportShipments: eqTransports[],
    isf: string;
    originCustomsClearance: string,
    opsStatus:string,
    originOffice: string,
    originTrucking: string,
    plant: string,
    purchaseOrganisation: string,
    quantity: number,
    serviceAtDestination: string,
    serviceAtOrigin: string,
    shipmentTypeAtDestination: string,
    placeOfConsolidationCode: string,
    shipmentTypeAtOrigin: string,
    size: string,
    status:string,
    subType: string,
    substitutionSize: string,
    substitutionType: string,
    totalPackages: number,
    type: string,
    updatedDate: string,
    vgm: string,
    volume: number,
    weight: number,
    voyages: any[]
    billingDocuments: any[]
    emptyReturnLocationCode?: string
    emptyReturnLocationName?: string
}
export interface eqTransports{
    id:number,
    anyIssoSent:boolean,
    createDate:string,
    equipmentNumber: string,
    shipmentNumber: string,
    equipmentSealNumber:string,
    equipmentTransportShipmentDocumentNumber:string,
    equipmentTransportShipmentId:number,
    isCancelled:boolean,
    issos: issos[],
    packages: number,
    volume: number,
    quantity: number,
    weight: number,
    lastUpdateDate:string
}
export interface issos {
    brainResponseStatusCode:number,
    changedFinancialFields:string | null,
    correlationId:string,
    errors: string,
    financialChangeIndicator: string,
    generationDate:string,
    isSent:boolean,
    issoId: number,
    issoNumber:string,
    messageType:string
}
export const EmptyEquipmentDetail:IEquipmentDetail = {
    destinationCustomsClearance: '',
    destinationOffice: '',
    destinationTrucking: '',
    equipmentId: 0,
    equipmentNumber: '',
    purchaseOrganisation: '',
    isf: '',
    originCustomsClearance: '',
    opsStatus: '',
    originOffice: '',
    originTrucking: '',
    plant: '',
    serviceAtDestination: '',
    serviceAtOrigin: '',
    shipmentTypeAtDestination: '',
    shipmentTypeAtOrigin: '',
    placeOfConsolidationCode: '',
    status:'',
    totalPackages: 0,
    type: '',
    substitutionType: '',
    size: '',
    subType: '',
    substitutionSize: '',
    sealNumber1: '',
    deliveryMovementType: '',
    pickUpMovementType: '',
    quantity: 0,
    weight: 0,
    vgm: '',
    volume: 0,
    createDate:'',
    updatedDate:'',
    equipmentParty: {
        companyCode: '',
        issuerCountryCode: '',
        placeOfDeliveryCode: '',
        placeOfDeliveryName:  '',
        placeOfReceiptCode: '',
        placeOfReceiptName: '',
        portOfDischargeCode: '',
        portOfDischargeName: '',
        portOfLoadingCode: '',
        portOfLoadingName: '',
        issuerBECode:'',
        salesArea: ''
    },
    bookings: [],
    clrs: [],
    cbls: [],
    documents: [],
    equipmentTransportShipments: [],
    voyages: [],
    billingDocuments:[]
}

export interface IEquipmentHeader {
    equipmentId: number,
    equipmentNumber: string,
    sealNumber1: string,
    deliveryMovementType: string,
    pickUpMovementType: string,
    opsStatus:string,
    quantity: number,
    serviceAtDestination: string,
    serviceAtOrigin: string,
    shipmentTypeAtDestination: string,
    placeOfConsolidationCode: string,
    shipmentTypeAtOrigin: string,
    size: string,
    status:string,
    subType: string,
    substitutionSize: string,
    substitutionType: string,
    totalPackages: number,
    type: string,
    updatedDate: string,
    volume: number,
    weight: number,
    createDate: string
}

export const IEquipmentHeaderEmpty: IEquipmentHeader = {
    equipmentId: 0,
    equipmentNumber: '',
    sealNumber1: '',
    deliveryMovementType: '',
    pickUpMovementType: '',
    opsStatus: '',
    quantity: 0,
    serviceAtDestination: '',
    serviceAtOrigin: '',
    shipmentTypeAtDestination: '',
    placeOfConsolidationCode: '',
    shipmentTypeAtOrigin: '',
    size: '',
    status: '',
    subType: '',
    substitutionSize: '',
    substitutionType: '',
    totalPackages: 0,
    type: '',
    updatedDate: '',
    volume: 0,
    weight: 0,
    createDate: ''
}

export interface IEquipmentDetailsCostAndRevenue {
    bookingSplitId: number,
    bookingId: number,
    bookingNumber: string,
    documentId: number,
    documentNumber: string,
    cblId: number,
    cblNumber: string,
    equipmentId: number,
    equipmentNumber: string,
    containerType: string,
    containerSize: string,
    substitutionType: string,
    substitutionSize: string
}

export const  IEquipmentDetailsCostAndRevenueEmpty : IEquipmentDetailsCostAndRevenue = {
    bookingSplitId: 0,
    bookingId: 0,
    bookingNumber: '',
    documentId: 0,
    documentNumber: '',
    cblId: 0,
    cblNumber: '',
    equipmentId: 0,
    equipmentNumber: '',
    containerType: '',
    containerSize: '',
    substitutionType: '',
    substitutionSize: ''
}
